import React from "react";
import ProductsList from "../Components/ProductsList";

const MyProducts = () => {
  return (
    <div>
      <ProductsList />
    </div>
  );
};
export default MyProducts;
